module.exports = __webpack_public_path__ + "static/img/help10.6f51e57a.png";